import { FetchResult, FetchResultType } from '@/entities/FetchResult'
import { StreamTokenResource } from '@/entities/StreamToken/StreamToken'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { trans } from '@/helpers/trans'
import { generateApiV3Url } from '@/helpers/url'

/**
 * Resolves to `null` when the current user is not meant to be connected to Stream.
 */
export const getStreamTokenApiCall = async (): Promise<FetchResult<string | null, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: '/users/profile/me/stream-token' })
        const response = await authorizedFetch(url)

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const resource: StreamTokenResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: resource.token || null,
        }
    } catch (error) {
        console.error('[getStreamTokenApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
